export const MEDAL_TABLE = [
  {
    name: 'США',
    code: 'US',
    medals: {
      gold: 39,
      silver: 41,
      bronze: 33,
      total: 113
    },
    position: 1
  },
  {
    name: 'Китай',
    code: 'CN',
    medals: {
      gold: 38,
      silver: 32,
      bronze: 18,
      total: 88
    },
    position: 2
  },
  {
    name: 'Япония',
    code: 'JP',
    medals: {
      gold: 27,
      silver: 14,
      bronze: 17,
      total: 58
    },
    position: 3
  },
  {
    name: 'Великобритания',
    code: 'GB',
    medals: {
      gold: 22,
      silver: 21,
      bronze: 22,
      total: 65
    },
    position: 4
  },
  {
    name: 'ОКР',
    code: 'RU',
    medals: {
      gold: 20,
      silver: 28,
      bronze: 23,
      total: 71
    },
    position: 5
  },
  {
    name: 'Казахстан',
    code: 'KZ',
    medals: {
      gold: 0,
      silver: 0,
      bronze: 8,
      total: 8
    },
    position: 83
  }
];
